// src/components/PipelineStats.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Grid, Paper, Typography, CircularProgress, Alert } from '@mui/material';

const PipelineStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/dashboard/stats');
        setStats(response.data);
      } catch (error) {
        console.error("Failed to fetch dashboard stats", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return <CircularProgress sx={{ mb: 4 }} />;
  }
  if (!stats) {
    return <Alert severity="error" sx={{ mb: 4 }}>Could not load event statistics.</Alert>;
  }

  const totalAttendance = stats.AttendanceByDay.reduce((acc, day) => acc + day.Count, 0);

  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={3}>
        <Paper sx={{ p: 2, textAlign: 'center', backgroundColor: '#e3f2fd', color: '#0d47a1' }}>
          <Typography variant="h6">Total Participants</Typography>
          <Typography variant="h3" component="p" fontWeight="bold">{stats.TotalParticipants}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Paper sx={{ p: 2, textAlign: 'center', backgroundColor: '#e8f5e9', color: '#1b5e20' }}>
          <Typography variant="h6">Financially Cleared</Typography>
          <Typography variant="h3" component="p" fontWeight="bold">{stats.TotalFinanciallyCleared}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Paper sx={{ p: 2, textAlign: 'center', backgroundColor: '#f3e5f5', color: '#4a148c' }}>
          <Typography variant="h6">Onboarded</Typography>
          <Typography variant="h3" component="p" fontWeight="bold">{stats.TotalOnboarded}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Paper sx={{ p: 2, textAlign: 'center', backgroundColor: '#fff3e0', color: '#e65100' }}>
          <Typography variant="h6">Total Check-Ins</Typography>
          <Typography variant="h3" component="p" fontWeight="bold">{totalAttendance}</Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PipelineStats;